/**
 * 性能分析器类型定义
 */
/**
 * 性能分析类别
 */
export var ProfileCategory;
(function (ProfileCategory) {
    /** ECS 系统 */
    ProfileCategory["ECS"] = "ECS";
    /** 渲染相关 */
    ProfileCategory["Rendering"] = "Rendering";
    /** 物理系统 */
    ProfileCategory["Physics"] = "Physics";
    /** 音频系统 */
    ProfileCategory["Audio"] = "Audio";
    /** 网络相关 */
    ProfileCategory["Network"] = "Network";
    /** 用户脚本 */
    ProfileCategory["Script"] = "Script";
    /** 内存相关 */
    ProfileCategory["Memory"] = "Memory";
    /** 动画系统 */
    ProfileCategory["Animation"] = "Animation";
    /** AI/行为树 */
    ProfileCategory["AI"] = "AI";
    /** 输入处理 */
    ProfileCategory["Input"] = "Input";
    /** 资源加载 */
    ProfileCategory["Loading"] = "Loading";
    /** 自定义 */
    ProfileCategory["Custom"] = "Custom";
})(ProfileCategory || (ProfileCategory = {}));
/**
 * 默认配置
 */
export const DEFAULT_PROFILER_CONFIG = {
    enabled: false,
    maxFrameHistory: 300,
    maxSampleDepth: 32,
    collectMemory: true,
    memorySampleInterval: 100,
    detectLongTasks: true,
    longTaskThreshold: 50,
    enabledCategories: new Set(Object.values(ProfileCategory))
};
//# sourceMappingURL=ProfilerTypes.js.map